import { useEffect, useMemo, useRef, useState } from 'react';
import { IModelData } from '../types/interfaces';
import VehicleModelsEditMainInfo from './VehicleModelsEditMainInfo';
import VehicleModelsEditSidebar from './VehicleModelsEditSidebar';
import VehicleModelsEditGallery from './VehicleModelsEditGallery/VehicleModelsEditGallery';
import { useTranslation } from 'react-i18next';
import VehicleModelsEditExterior from './VehicleModelsEditExterior/VehicleModelsEditExterior';
import VehicleModelsEditSeo from './VehicleModelsEditSeo';
import VehiclModelsEditSpecificationsTable from './VehiclModelsEditSpecificationsTable';
import { useSearchParams } from 'react-router-dom';

export default function VehicleModelsEditLayout({ data }: { data: IModelData }) {
  const { t } = useTranslation();

  const formRef = useRef(null);
  const tabsData = useMemo(() => (
    [
      {
        id: 1,
        name: t('main_info'),
        slug: 'main-info',
        content: <VehicleModelsEditMainInfo key={`main_info_model`} />
      },
      {
        id: 2,
        name: t('gallery_images'),
        slug: 'gallery-images',
        content: <VehicleModelsEditGallery key={`gallery_images_model`} images={data?.gallery || []} />
      },
      {
        id: 3,
        name: t('exterior_color_images'),
        slug: 'exterior-colors',
        content: <VehicleModelsEditExterior key={`exterior_color_model`} title={t('exterior_color_images')} />
      },
      {
        id: 6,
        name: t('interior_color_images'),
        slug: 'interior-colors',
        content: <VehicleModelsEditExterior key={`interior_color_model`} title={t('interior_color_images')} interior />
      },
      {
        id: 5,
        name: t('specifications'),
        slug: 'specs',
        content: <VehiclModelsEditSpecificationsTable key={`specifications_model`} />
      },
      {
        id: 7,
        name: t('seo'),
        slug: 'seo',
        content: <VehicleModelsEditSeo key={`seo_model`} />
      }
      // {
      //   id: 8,
      //   name: t('model_group'),
      //   slug: 'model-group',
      //   content: <div>{t('model_group')}</div>
      // }
    ]
  ), [t, data])

  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  function findCurrentTabIndex(){
    const tabIndex = tabsData?.findIndex(item => item.name === tab)
    return tabIndex === -1 ? 0 : tabIndex
  }

  const [activeTab, setActiveTab] = useState(findCurrentTabIndex());

  useEffect(() => {
    setActiveTab(findCurrentTabIndex())
  }, [tab])

  return (
    <div className="model-edit" ref={formRef}>
      <VehicleModelsEditSidebar data={tabsData} activeTab={activeTab} setActiveTab={setActiveTab} />
      {tabsData[activeTab]?.content}
    </div>
  );
}
